import { UserErrorAlert } from "@/components/UserErrorAlert"
import { Skeleton } from "@/components/ui/skeleton"

// One shared loading/error treatment for the only query this site makes --
// the public subscription-plan catalog behind the pricing section -- so a
// slow or failed Supabase read looks deliberate instead of blank.

/** Same outer frame for both states so swapping them does not jump. */
export const queryStateFrameClassName =
  "flex flex-col items-center gap-3 py-12 text-center"

export function LoadingState() {
  return (
    <div className={queryStateFrameClassName} role="status" aria-label="Loading">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-4 w-48" />
      <Skeleton className="h-4 w-40" />
    </div>
  )
}

export function ErrorState({ error }: { error: unknown }) {
  return <UserErrorAlert error={error} prefix="Something went wrong loading this:" />
}
